/**
 * ReviewCta — the Review-step call to action: a SplitButton whose default path
 * is "Create draft" and whose alternate is "Create & add another" (BON-203 R5).
 *
 * Extracted from CreateWorkshopDrawer so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
import { SplitButton } from '../../primitives';

import type { WorkshopCreateForm } from './useWorkshopCreateForm';

export function ReviewCta({
  form,
  label,
  canContinue,
}: {
  form: WorkshopCreateForm;
  label: string;
  canContinue: boolean;
}) {
  return (
    <SplitButton
      label={label}
      disabled={!canContinue}
      menuLabel="More create options"
      onClick={() => form.submit('navigate')}
      options={[
        {
          id: 'add-another',
          label: 'Create & add another',
          onSelect: () => form.submit('addAnother'),
        },
      ]}
    />
  );
}
